export default "__VITE_ASSET__BInZYXnE__"